
import { Controller, useFormContext } from 'react-hook-form';
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import AsyncSelect from 'react-select/async';
import { HeaderInputComponent, LabelError } from '../Labels';
import classNames from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import { MarkDownViwer } from '../markDownViwer';

/**
 * Permite usar el componnete de select async con una funcion de busqueda
 * @param {*} param0 
 */
export const useSelectAsyncSearch = ({ queryfn, formatfn, loadInStart = false }) => {
    const [called, setCalled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [options, setOptions] = useState([]);

    const loadOptions = useCallback(async (inputValue, callback) => {
        if (isLoading) return;
        setIsLoading(true);
        setCalled(true);
        try {
            let _options = await queryfn(inputValue);
            _options = formatfn ? formatfn(_options) : _options;
            callback?.(_options);
            setOptions(_options);
            setIsError(false);
        } catch (error) {
            setIsError(true);
        }
        setIsLoading(false);
    }, [isLoading, queryfn, formatfn]);

    useEffect(() => {
        //cargar al inicio de la app 
        setCalled((_called) => {
            if (_called) return _called;
            setIsLoading((_isLoading) => {
                if (_isLoading) return _isLoading;
                console.log("loadInStart", loadInStart, _called, _isLoading, new Date().getTime());
                if (loadInStart) loadOptions();
                return _isLoading;
            })
            return _called
        })
    }, [loadOptions, loadInStart]);

    return { options, isLoading, called, isError, loadOptions, bind: { isLoading, loadOptions } };
}

export const SelectStyles = ({ viewmode }) => ({
    control: (base) => ({
        ...base,
        backgroundColor: viewmode ? "rgb(182 182 182 /0 )" : "rgb(182 182 182 /0.25 )",
        borderColor: "transparent",
        borderRadius: "4px",
        caretColor: "white",
        "&:hover": { borderColor: "transparent" }, // Borde en hover
    }),
    input: (provided) => ({
        ...provided,
        minHeight: '30px',
        color: "#F7F5F2",
        fontWeight: "bold", // Establece el color del texto del input a blanco
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? "#F2F2F2" : "#FEFEFE",
        color: "black",
        cursor: "pointer"
    }),
    dropdownIndicator: (base) => ({
        ...base,
        color: "#FEFEFE", // Color del indicador
        "&:hover": {
            color: "#3FB2E3", // Color del indicador en hover
        },
    }),
    singleValue: (provided) => ({
        ...provided,
        color: "#fefefe", // Establece el color del texto de la opción seleccionada a blanco
        fontWeight: "bold",
    }),
    clearIndicator: (styles) => ({
        ...styles,
        color: "black", // Aquí puedes poner el color que desees
        ":hover": {
            color: "black", // Color cuando se pasa el ratón por encima (hover)
        },
    }),
    groupHeading: (provided, state) => ({
        ...provided,
        backgroundColor: state.data.label === "Primaria" ? "#28345C" : "#6F7792",
        color: "#fefefe",
        fontSize: ".65em",
        textTransform: "uppercase",
        paddingTop: "8px",
        paddingBottom: "8px",
    }),
    placeholder: (base) => ({
        ...base,
        fontWeight: 'bold', // Aplicar negrita al placeholder
    }),
    valueContainer: (provided) => ({
        ...provided,
        ...(viewmode ? { padding: 0 } : {}), // Establece el padding a 0
    }),
});

/**
 * Campo para el formulario de seleccion
 * @param {*} param0 
 * @returns 
 */
export const SelectableInput = ({ rules,formatOptionLabel, markdownviwer = false, isCreatable = true, selectStyles = SelectStyles, labelInstructio2ex, viewmode, options, labelInstructio3, label, labelInstruction, name, placeHolder, labelInstructio2, isMulti = false, onChange, isDisabled, labelInstructio4 }) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();
    return (
        <div className={classNames("input-text !mt-0 flex flex-col h-full")}>
            <HeaderInputComponent viewmode={viewmode} labelkey={label} labelInstructio2ex={isDisabled || viewmode ? null : labelInstructio2ex} labelInstructio3={isDisabled || viewmode ? null : labelInstructio3} labelInstruction={isDisabled || viewmode ? null : labelInstruction} labelInstructio2={isDisabled || viewmode ? null : labelInstructio2} labelInstructio4={labelInstructio4} />
            <div className="flex justify-around gap-2">
                <div className="w-full">
                    <Controller
                        name={name}
                        control={control}
                        rules={rules}
                        render={({ field }) => (
                            isCreatable || viewmode ?
                                <CreatableSelect
                                    {...field}
                                    onChange={(value) => {
                                        field.onChange(value);
                                        onChange?.(value);
                                    }}
                                    styles={selectStyles({ viewmode })}
                                    options={options}
                                    isMulti={isMulti}
                                    formatOptionLabel={formatOptionLabel}
                                    {...{
                                        ...(markdownviwer ? { formatOptionLabel: ({ label }) => <MarkDownViwer markdown={label} /> } : {}),

                                    }}
                                    isDisabled={isDisabled || viewmode}
                                    components={
                                        isDisabled || viewmode ? {
                                            DropdownIndicator: () => null,
                                            IndicatorSeparator: () => null,
                                            MultiValueRemove: () => null,
                                            ClearIndicator: () => null
                                        } : { ClearIndicator: () => null }
                                    }
                                    placeholder={placeHolder}
                                /> :
                                <Select
                                    {...field}
                                    onChange={(value) => {
                                        field.onChange(value);
                                        onChange?.(value);
                                    }}
                                    styles={selectStyles({ viewmode })}
                                    options={options}
                                    isMulti={isMulti}
                                    isDisabled={isDisabled}
                                    formatOptionLabel={formatOptionLabel}
                                    {...{
                                        ...(markdownviwer ? { formatOptionLabel: ({ label }) => <MarkDownViwer markdown={label} /> } : {}),

                                    }}
                                    components={
                                        isDisabled ? {
                                            DropdownIndicator: () => null,
                                            IndicatorSeparator: () => null,
                                            MultiValueRemove: () => null,
                                            ClearIndicator: () => null
                                        } : { ClearIndicator: () => null, }
                                    }
                                    placeholder={placeHolder}
                                />
                        )}
                    />
                    <LabelError errors={errors} name={name} />
                </div>
            </div>
        </div>
    );
}

export const SelectComponent = (props) => {
    const { isCreatable, viewmode, placeHolder, selectStyles = SelectStyles, ...restprops } = props;
    if (isCreatable || viewmode) {
        return (
            <CreatableSelect styles={selectStyles({ viewmode })} placeholder={placeHolder} {...restprops} />
        );
    } else {
        return (
            <Select styles={selectStyles({ viewmode })} placeholder={placeHolder} {...restprops} />
        );
    }
}


/**
 * Campo para el formulario de seleccion asyncrona
 * @param {*} param0 
 * @returns 
 */
export const SelectableInputAsync = ({ rules, onInputChange, bind = {}, selectStyles = SelectStyles, viewmode, labelInstructio3, label, labelInstruction, name, placeHolder, labelInstructio2, isMulti = false, onChange, isDisabled }) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();
    return (
        <div className={classNames("input-text mt-0 flex flex-col h-full")}>
            <HeaderInputComponent viewmode={viewmode} labelkey={label} labelInstructio3={isDisabled ? null : labelInstructio3} labelInstruction={isDisabled ? null : labelInstruction} labelInstructio2={isDisabled ? null : labelInstructio2} />
            <div className="flex justify-around gap-2">
                <div className="w-full">
                    <Controller
                        name={name}
                        control={control}
                        rules={rules}
                        render={({ field }) => (
                            <AsyncSelect
                                {...field}
                                {...bind}
                                onChange={(value) => {
                                    field.onChange(value);
                                    onChange?.(value);
                                }}
                                isMulti={isMulti}
                                isDisabled={isDisabled}
                                onInputChange={onInputChange}
                                components={
                                    isDisabled ? {
                                        DropdownIndicator: () => null,
                                        IndicatorSeparator: () => null,
                                        MultiValueRemove: () => null
                                    } : {}
                                }
                                placeholder={placeHolder}
                                styles={selectStyles({ viewmode })}
                                cacheOptions
                            />
                        )}
                    />
                    <LabelError errors={errors} name={name} />
                </div>
            </div>
        </div>
    );
}

/**
 * Permite Obtener informacion del api
 * @param {*} param0 
 * @returns 
 */
export const SelectableInputAsyncSearch = ({
    formatfn = (data) => data.map(({ id, name }) => ({ value: id, label: name })),
    queryfn,
    rules,
    onInputChange,
    selectStyles = SelectStyles,
    viewmode,
    labelInstructio3,
    label,
    labelInstruction,
    name,
    placeHolder,
    labelInstructio2,
    isMulti = false,
    onChange,
    isDisabled }) => {

    const { bind } = useSelectAsyncSearch({ queryfn, formatfn });

    return (
        <SelectableInputAsync {...{ rules, onInputChange, bind, selectStyles, viewmode, labelInstructio3, label, labelInstruction, name, placeHolder, labelInstructio2, isMulti, onChange, isDisabled }} />
    );
}